import { RecurrencyStatus, Period, PatternType, DaysOfWeek, WeekOfMonth, EndCondition } from '../enums';

export class RecurrencyPattern {
  id: number = 0;
  status: RecurrencyStatus = RecurrencyStatus.Planned;
  startDate: string = null;
  endDate: string = null;
  timeZoneName: string = 'UTC';
  period: Period = Period.Week;
  patternType: PatternType = PatternType.DaysOfWeek;
  daysOfWeek: DaysOfWeek = DaysOfWeek.None;
  dayOfMonth: number = 1;
  weekOfMonth: WeekOfMonth = WeekOfMonth.None;
  interval: number = 1;
  maxOccurrences: number = 0;
  endCondition: EndCondition = EndCondition.None;
  daysPrior: number = 1;
  occurrences: number = 0;
  lastOccurrenceDate: string = null;
  changeDate: string = null;
  startOccurrence: number = 0;
  deleted: boolean = false;
  isSuspended: boolean = false;
  suspendStartDate: string = null;
  suspendEndDate: string = null;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/recurrency-pattern.ts